import { DiningOptionController } from '../controllers/dining_option.controller';
import './dining_option.scss';
export const DiningOptionVariantComponent = {
    template: `
        <p class="text-left">Please select your order type</p>
        <form class="radio-bar">
            <input
                id="pickup-{{::$id}}"
                name="order-{{::$id}}"
                ng-checked="$ctrl.cartDisplay.diningOption === 'TAKE_OUT' && $ctrl.cartDisplay.enablePickup"
                ng-disabled="!$ctrl.cartDisplay.enablePickup"
                type="radio"
                value="pickup"
                />
                <label
                    class="PICKUP"
                    for="pickup-{{::$id}}"
                    id="landing-dining-option-pickup-input-label"
                    ng-click="$ctrl.makePickup()">
                    Pickup
                </label>
            <input
                id="delivery-{{::$id}}"
                name="order-{{::$id}}"
                ng-checked="$ctrl.cartDisplay.diningOption === 'DELIVERY' && $ctrl.cartDisplay.enableDelivery"
                ng-disabled="!$ctrl.cartDisplay.enableDelivery"
                type="radio"
                value="delivery"
                />
                <label
                    class="DELIVERY"
                    for="delivery-{{::$id}}"
                    id="landing-dining-option-delivery-input-label"
                    ng-click="$ctrl.makeDelivery()">
                    Delivery
                </label>
        </form>
    `,
    controller: DiningOptionController
};
